/** Endpoints the app shell reads on every signed-in screen. */
import { api } from '../client';
import type { Account, BillingSummary, Connection, CurrentUser, PredictionAdminIdentity } from '../types';

export const shellApi = {
  me: (signal?: AbortSignal, options?: { skipAuthRedirect?: boolean }) =>
    api.get<CurrentUser>('/api/user/me', { signal, ...options }),
  account: (signal?: AbortSignal) => api.get<Account>('/api/account/', { signal }),
  billingSummary: (signal?: AbortSignal) => api.get<BillingSummary>('/api/billing/summary', { signal }),
  predictionAdminIdentity: (signal?: AbortSignal) =>
    api.get<PredictionAdminIdentity>('/api/admaster/prediction/admin/me', { signal }),
  connections: (signal?: AbortSignal) => api.get<Connection[]>('/api/admaster/connection', { signal }),
};
